import Axios from '@/api/http'
/**
 * 获取登录日志列表
 * */
export function getuserloginlist(date) {
  return Axios({
    method: 'post',
    url: '/api/getuserloginlist',
    data: date,
  })
}
/**
 * 获取操作日志列表
 * */
export function getuserloglist(date) {
  return Axios({
    method: 'post',
    url: '/api/getuserloglist',
    data: date,
  })
}
